import { render } from "./ListButton.vue?vue&type=template&id=2b2cae6e&ts=true"
import script from "./ListButton.vue?vue&type=script&lang=ts"
export * from "./ListButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__